import NavigateProjectContentsAsTable from 'viewmodel/NavigateProjectContentsAsTableViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';
import * as ReactDOM from 'react-dom';
import { registerDynImportEntry } from 'js/moduleLoader';

registerDynImportEntry('image/miscChevronRight16.svg', () => import('image/miscChevronRight16.svg'));

const COLLABORATIONSPACE_ID = 'collaborationspace-id';
const ROLE_FILTERS = 'role-filters';
const OWNERSHIP_FILTERS = 'ownership-filters';

export default class DesNavigateProjectContentsAsTable extends DesBaseCollabAcc {

    constructor() {
        super(NavigateProjectContentsAsTable);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute(COLLABORATIONSPACE_ID);
    }

    get roleFilters() {
        return this.getAttribute(ROLE_FILTERS);
    }

    get ownershipFilters() {
        return this.getAttribute(OWNERSHIP_FILTERS);
    }

    get ixenabled() {
        window.ixEnabled = this.getAttribute('ix-enabled') || this.getAttribute('ixenabled');
        return this.getAttribute('ix-enabled') || this.getAttribute('ixenabled');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            projectid: this.getAttribute('project-id'),
            ixEnabled: this.ixenabled
        };
    }

    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }

    static get observedAttributes() {
        return [...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', COLLABORATIONSPACE_ID,
            'project-id', 'ix-enabled', 'ixenabled'];
    }
}
if (!window.customElements.get('des-navigate-project-contents-as-table')) {
    window.customElements.define(
        'des-navigate-project-contents-as-table',
        DesNavigateProjectContentsAsTable
    );
}
